import { render, staticRenderFns } from "./Plantilla.vue?vue&type=template&id=1cb64090&scoped=true&"
import script from "./Plantilla.vue?vue&type=script&lang=js&"
export * from "./Plantilla.vue?vue&type=script&lang=js&"
import style0 from "./Plantilla.vue?vue&type=style&index=0&id=1cb64090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb64090",
  null
  
)

export default component.exports